var exports = {
  "carousel": "xdbfd91f1--7bb06e--carousel",
  "hidden": "xdbfd91f1--7bb06e--hidden",
  "carousel-item": "xdbfd91f1--7bb06e--carousel-item",
  "carousel-item--odd": "xdbfd91f1--7bb06e--carousel-item--odd",
  "carousel-item--even": "xdbfd91f1--7bb06e--carousel-item--even",
  "carousel-img": "xdbfd91f1--7bb06e--carousel-img",
  "carousel-animated": "xdbfd91f1--7bb06e--carousel-animated",
  "animateSlide": "xdbfd91f1--7bb06e--animateSlide",
};

module.exports = exports;
